export default __webpack_public_path__ + "static/media/Frame (2).460656a6.png";